/* ============================================================
   Reformly Board PDP — tab panels (program week stages).

   Two panel groups move together: the copy column and the media
   column, both keyed by index. Kept as one handler so they can
   never drift out of sync.

   Full ARIA tab semantics including arrow-key roving focus, which
   the export did not implement.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.bpTabsReady === '1') return;
    root.dataset.bpTabsReady = '1';

    var tabs = root.querySelectorAll('[data-bp-tab]');
    if (!tabs.length) return;

    function select(i, focus) {
      for (var t = 0; t < tabs.length; t++) {
        var on = String(t) === String(i);
        tabs[t].setAttribute('aria-selected', on ? 'true' : 'false');
        tabs[t].setAttribute('tabindex', on ? '0' : '-1');
        if (on && focus) tabs[t].focus();
      }
      // Only the copy panels switch now. The media column holds ONE video
      // for the whole card (the export does the same), so there is no
      // second group keyed by index any more.
      var panels = root.querySelectorAll('[data-bp-panel]');
      for (var p = 0; p < panels.length; p++) {
        var idx = panels[p].getAttribute('data-bp-panel');
        if (String(idx) === String(i)) panels[p].removeAttribute('hidden');
        else panels[p].setAttribute('hidden', '');
      }
    }

    for (var t = 0; t < tabs.length; t++) {
      (function (i) {
        tabs[i].addEventListener('click', function () { select(i, false); });
        tabs[i].addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
          else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') n = 0;
          else if (e.key === 'End') n = tabs.length - 1;
          if (n === null) return;
          e.preventDefault();
          select(n, true);
        });
      })(t);
    }
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-bp-tabs]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* Pause / play toggle for the 60-day plan panel video. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bp-pause]');
    if (!btn) return;
    var wrap = btn.closest('.rbp-plan__media');
    if (!wrap) return;
    // Only the visible panel's video — the others are [hidden].
    // One video in the card; no longer nested in per-stage panels.
    var vid = wrap.querySelector('video');
    if (!vid) return;
    var label = btn.querySelector('[data-bp-pause-label]');

    // One state flag drives all three: icon (via CSS), visible label, and
    // the accessible name. Previously only the label changed, so the pause
    // bars stayed on screen while the button read "Play".
    function paint(paused) {
      btn.classList.toggle('is-paused', paused);
      if (label) label.textContent = paused ? 'Play' : 'Pause';
      btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }

    if (vid.paused) {
      vid.play();
      paint(false);
    } else {
      vid.pause();
      paint(true);
    }

    // The video can also stop on its own (end of a non-looping clip, or
    // the browser suspending playback), so mirror its real state.
    if (!vid.dataset.bpPauseBound) {
      vid.dataset.bpPauseBound = '1';
      vid.addEventListener('play', function () { paint(false); });
      vid.addEventListener('pause', function () { paint(true); });
    }
  });
})();
